import moment from "moment";
import type { FC } from "react";
interface DurationLabelProps {
    duration: string;
}
const DurationLabel: FC<DurationLabelProps> = (props) => {
    const duration = moment.duration(props.duration);
    return <span title={props.duration}>{duration.humanize()}</span>;
};
export default DurationLabel;
